import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnalyticButton } from "cm-component-library/lib/CMLayout/Navbar/";
import { withRouter, RouteComponentProps } from "react-router";
import { AdvancedSearchAction, toggleTimelineDropdown } from "../Actions/AdvancedSearchActions";
import { IAppState, appPaths } from "../../Common";

type StateProps = {
  isDropdownShowing: boolean;
};

type DispatchProps = {
  toggleTimelineDropdown: () => void;
};

function mapStateToProbs(state: IAppState): StateProps {
  return {
    isDropdownShowing: state.advancedSearch.isTimelineDropdownShowing
  };
}

function mapDispatchToProps(
  dispatch: ThunkDispatch<IAppState, {}, AdvancedSearchAction>
): DispatchProps {
  return {
    toggleTimelineDropdown: () => dispatch(toggleTimelineDropdown())
  };
}

class TimelineToggleButton extends React.Component<
  StateProps & DispatchProps & RouteComponentProps
> {
  constructor(props: StateProps & DispatchProps & RouteComponentProps) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.toggleTimelineDropdown();
  }

  render() {
    const isFilterActive = this.props.location.pathname === appPaths.search.advanced;

    const title = isFilterActive ? "Timeline (Filter is Active)" : "Timeline";

    return (
      <AnalyticButton
        title={title}
        isActive={this.props.isDropdownShowing}
        isFilterActive={isFilterActive}
        onClick={this.onToggle}
      />
    );
  }
}

export default connect(
  mapStateToProbs,
  mapDispatchToProps
)(withRouter(TimelineToggleButton));
